import { VideoDisplayMode } from "../../types";
import { MediaPlayerInterface } from "./useMediaPlayer";

/**
 * Used for delaying rendering of anything that will rerender once the video
 * element is ready.
 */
export const videoElementComplete = (
  player: MediaPlayerInterface,
  videoDisplayMode: VideoDisplayMode
): boolean => {
  const elementWillNotBeCreated = [
    VideoDisplayMode.PROCESSING,
    VideoDisplayMode.NO_RECORDING,
  ].includes(videoDisplayMode);
  return elementWillNotBeCreated || player.elementReady;
};
